import { type AddressLight } from "shared/apiClient";

import { useGetObjectsNearAddress } from "shared/apiHooks";

import { MapComponent } from "shared/components";

export interface SiteOverviewMapProps {
  address: AddressLight | undefined | null;
}

export function SiteOverviewMap({ address }: SiteOverviewMapProps) {
  const { data: nearObjectsResponse } = useGetObjectsNearAddress({
    path: {
      address_id: address?.id || "",
    },
  });

  return (
    <MapComponent
      latitude={address?.gps_latitude ?? undefined}
      longitude={address?.gps_longitude ?? undefined}
      addressBoundary={address?.boundary ?? undefined}
      nearObjects={nearObjectsResponse?.data.near_objects ?? undefined}
      className="max-h-[200px] min-h-[200px] w-full rounded bg-[#E3E2E1] md:max-h-[350px] md:min-h-[350px]"
    />
  );
}
